import { watch } from 'vue';
import { useStore } from 'vuex';

export function addNavigationPath(source, path) {
    const store = useStore();
    
    // Handle raw booleans or computed refs seamlessly
    const getter = typeof source === 'boolean' ? () => source : source;

    const stopKB = watch(getter, (newVal) => {
        if (newVal) {
            store.commit('addNavigationPath', path);
            stopKB();
        }
    }, { immediate: true }); // <--- Runs right away on mount!
}